import { globalEntitlements } from '../utils/globalEntitlements';

/** @typedef {import('../types').ProductLandingConfig} ProductLandingConfig */

/** @type {ProductLandingConfig} */
export const FUNDBOX_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.fundbox.buyBox.bulletPoint1' },
        { title: 'productPage.fundbox.buyBox.bulletPoint2' },
        { title: 'productPage.fundbox.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.fundbox.buyBox.productName',
      interactService: {
        ctaType: 'externalCheckout',
        service: 'fundbox',
        openInNewTab: true
      }
    }],
    headerPicture: {
      src: '/s2/raster/glasses-review-documents.png',
      alt: 'productPage.fundbox.heroPicture.altText'
    },
    headline: 'productPage.fundbox.page.headline',
    partnerLogo: {
      src: '/s2/vector/fundbox-logo.svg',
      alt: 'productPage.fundbox.partnerLogo.altText'
    },
    partnerReviewBlanks: [], // Fundbox has no partner review data to display
    subheader: 'productPage.fundbox.page.subheader'
  },
  benefit: {
    title: 'productPage.fundbox.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/paymentsrounded.svg',
        title: 'productPage.fundbox.valueProp.propTitle1',
        description: 'productPage.fundbox.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/trendinguprounded.svg',
        title: 'productPage.fundbox.valueProp.propTitle2',
        description: 'productPage.fundbox.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/shieldrounded.svg',
        title: 'productPage.fundbox.valueProp.propTitle3',
        description: 'productPage.fundbox.valueProp.shortCopy3'
      }
    ]
  },
  howItWorks: {
    title: 'productPage.fundbox.howItWorks.title',
    items: [
      {
        title: 'productPage.fundbox.howItWorks.step1',
        description: 'productPage.fundbox.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.fundbox.howItWorks.step2',
        description: 'productPage.fundbox.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.fundbox.howItWorks.step3',
        description: 'productPage.fundbox.howItWorks.shortDescription3'
      },
      {
        title: 'productPage.fundbox.howItWorks.step4',
        description: 'productPage.fundbox.howItWorks.shortDescription4'
      }
    ],
    image: '/s2/raster/laptop-creditcard-business.png',
    alt: 'productPage.fundbox.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  whatsIncluded: {
    title: 'productPage.fundbox.whatsIncluded.title',
    items: [
      {
        title: 'productPage.fundbox.whatsIncluded.item1',
        description: 'productPage.fundbox.whatsIncluded.item1ShortDescription'
      },
      {
        title: 'productPage.fundbox.whatsIncluded.item2',
        description: 'productPage.fundbox.whatsIncluded.item2ShortDescription'
      },
      {
        title: 'productPage.fundbox.whatsIncluded.item3',
        description: 'productPage.fundbox.whatsIncluded.item3ShortDescription'
      }
    ],
    image: '/s2/raster/reading-documents-home.png',
    alt: 'productPage.fundbox.whatsIncluded.altText',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false
  },
  footnotes: {
    divider: true,
    items: [
      {
        text: 'productPage.fundbox.footnotes.1.text'
      },
      {
        text: 'productPage.fundbox.footnotes.2.text'
      }
    ]
  },
  assistance: {
    title: 'productPage.fundbox.needAssistance.title',
    getInTouch: 'productPage.fundbox.needAssistance.getInTouch',
    actions: 'productPage.fundbox.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.fundbox.buyBox.buttonLabel'
  }).allowMultiplePurchases().build()
};
